import { css } from '@emotion/css';

export const headerStyles = css`
  &.BaseTable__header-row {
    background-color: var(--bg-primary);
    border-bottom: none;
  }
`;

export const rowStyles = css`
  &.BaseTable__row {
    border-bottom: none;

    :hover {
      background-color: var(--bg-primary);

      .task-list-item {
        background-color: var(--bg-secondary);
      }
    }
  }
  &.selected {
    .task-list {
      background: var(--bg-hover);
    }
  }
`;
